import React from "react";
import { TeamScope } from "@/contexts/TeamScopeContext";
import MyAppraisalsPage from "@/pages/admin/performance/MyAppraisalsPage";
import GoalsPage from "@/pages/admin/performance/GoalsPage";
import ManagerAppraisalEditor from "@/pages/admin/performance/components/appraisal/ManagerAppraisalEditor";
import PIPForm from "@/pages/admin/performance/PIPForm";
import ExitInterviewForm from "@/pages/admin/performance/ExitInterviewForm";

// "My team" pages: the admin review and goal pages, scoped to the manager's
// direct reports (see contexts/TeamScopeContext.js). `basePath` is /team in the
// admin layout and /employee/team in the employee portal.

export const TeamReviews = ({ basePath }) => (
  <TeamScope basePath={basePath}>
    <MyAppraisalsPage />
  </TeamScope>
);

export const TeamAppraisal = ({ basePath }) => (
  <TeamScope basePath={basePath}>
    <ManagerAppraisalEditor />
  </TeamScope>
);

export const TeamPIP = ({ basePath }) => (
  <TeamScope basePath={basePath}>
    <PIPForm />
  </TeamScope>
);

export const TeamExitInterview = ({ basePath }) => (
  <TeamScope basePath={basePath}>
    <ExitInterviewForm />
  </TeamScope>
);

export const TeamGoals = ({ basePath }) => (
  <TeamScope basePath={basePath}>
    <GoalsPage />
  </TeamScope>
);
